<template>
    <div>
        <div class="value-wrapper" v-if="rows.length">
            <!--<div class="value-line">
                <div class="left">
                    Værdi, kostpris i alt
                </div>
                <div class="right">
                    {{ totalValue | currency }}
                </div>
            </div>-->
            <div class="value-line">
                <div class="left">
                    Værdi, salgspris i alt
                </div>
                <div class="right">
                    {{ totalValueWithCP | currency }}
                </div>
            </div>
        </div>
        <div class="g-table-wrapper">
            <div class="table-title">
                <d-tooltip placement="left" identifier="projects.ongoingProjects" />
                Igangværende opgaver ({{ employeeName }})
            </div>
            <vue-good-table
                :columns="columns"
                :rows="rows"
                :search-options="searchOptions"
                :pagination-options="paginationOptions"
                :sort-options="sortOptions"
                :styleClass="styleClass"
                v-if="!loading"
            >
                <div slot="emptystate">
                    Ingen data ...
                </div>
                <template slot="table-row" slot-scope="props">
                    <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                        {{ props.row.coverage_percent | coveragePercent }} 
                        <div
                            v-if="props.row.coverage_percent !== null"
                            class="coverage-indicator"
                            :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                        />
                    </div>
                    <div class="coverage-cell" v-else-if="props.column.field == 'status.name'">
                        {{ props.row.status.name }}
                        <div class="coverage-indicator status" :style="'background:#' + props.row.status.color + ';'" />
                    </div>
                    <div v-else-if="props.column.field == 'case_number'" class="table-column__ordernumber" style="text-align:left;">
                        {{ props.row.case_number }}
                    </div>
                    <div v-else-if="props.column.field == 'description'" class="table-column__description">
                        <budget-tooltip :project="props.row" v-if="props.row.calculation_price > 499 || props.row.calculation_cost > 499" />
                        <span :title="props.row.description ? props.row.description : '-'">{{ props.row.description ? props.row.description : '-' }}</span>
                    </div>
                    <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer" :title="props.row.customer ? props.row.customer.name : '-'">
                        <i class="fal fa-map-marker-alt" style="margin-left:2px;" v-tooltip="{
                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
                        }" v-if="props.row.installation_address"></i>
                        {{ props.row.customer ? props.row.customer.name : '-' }}
                    </div>
                    <div v-else-if="props.column.field == 'action'" class="g-table__action" @click="openExternalLink(props.row.external_id)">
                        <i class="fad fa-eye" />
                    </div>
                    <div v-else-if="props.column.field == 'start_date'">
                        {{ props.row.start_date | moment("DD. MMM YYYY") }}
                    </div>
                    <div v-else-if="props.column.field == 'type.name'" class="table-column__description" :title="props.row.type ? props.row.type.name : '-'">
                        {{ props.row.type ? props.row.type.name : '-' }}
                    </div>
                    <div v-else-if="props.column.field == 'invoices_total'">
                        <span v-if="props.row.invoices_total > 0">{{ props.row.invoices_total | currency }}</span>
                        <span v-else>-</span>
                    </div>
                    <div v-else-if="props.column.field == 'total_expenses'">
                        <span v-if="props.row.total_expenses > 0">
                            {{ props.row.total_expenses | currency }}
                        </span>
                        <span v-else>-</span>
                    </div>
                    <div v-else-if="props.column.field == 'value'">
                        <project-tooltip :valueBased="true" :project="props.row" />
                        {{ props.row.value | currency }}
                    </div>
                    <div v-else-if="props.column.field == 'value_with_avg_cp'">
                        <project-tooltip :valueBased="true" :valueBasedWithCP="true" :project="props.row" />
                        {{ props.row.value_with_avg_cp | currency }}
                    </div>
                    <div v-else-if="props.column.field == 'minuba_external_id'">
                        <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                            <i class="fas fa-eye"></i>
                        </a>
                    </div>
                    <div v-else :title="props.formattedRow[props.column.field]">
                        {{ props.formattedRow[props.column.field] }}
                    </div>
                </template>
            </vue-good-table>   

            <box-loading height="350" v-else />
        </div>
    </div>
</template>

<script>
import shared from '../../../../../components/tables/projects/shared.js'
import * as projectService from '@/services/projectService'

export default {
    props: [
        'title',
        'rpp',
        'employeeId',
        'employeeName'
    ],
    data () {
        return {
            loading: true,
            columns: [
                { label: 'Ordre', field: 'case_number', type: 'number' },
                { label: 'Kunde', field: 'customer.name', type: 'string' },
                { label: 'Opgavetype', field: 'type.name', type: 'string' },
                { label: 'Opgave', field: 'description', type: 'string' },
                { label: 'Startdato', field: 'start_date', type: 'string' },
                { label: 'Status', field: 'status.name', type: 'string' }
            ],
            rows: [],
            searchOptions: {
                ...shared.searchOptions
            },
            paginationOptions: {
                ...shared.paginationOptions
            },
            sortOptions: {
                ...shared.sortOptions
                /* initialSortBy: {
                    field: 'type.name',
                    type: 'desc'
                } */
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        // if (this.$auth.user().roles[0].name === 'super-admin') {
            /* this.columns.push({ label: 'Aconto', field: 'aconto_billed' })
            this.columns.push({ label: 'Timer/materialer', field: 'hours_and_materials' })
            this.columns.push({ label: 'Værdi', field: 'value', type: 'number' }) */
            this.columns = [
                { label: 'Ordre', field: 'case_number', type: 'number' },
                { label: 'Kunde', field: 'customer.name', type: 'string' },
                // { label: 'Inst. adresse', field: 'installation_address.full_text', type: 'string' },
                { label: 'Opgavetype', field: 'type.name', type: 'string' },
                { label: 'Opgave', field: 'description', type: 'string' },
                { label: 'Aconto', field: 'invoices_total', type: 'number' },
                { label: 'Timer/materialer, kostpris', field: 'total_expenses', type: 'number' },
                // { label: 'Værdi, kostpris', field: 'value', type: 'number' },
                { label: 'Værdi, salgspris', field: 'value_with_avg_cp', type: 'number' },
                // { label: 'Startdato', field: 'start_date', type: 'string' },
                { label: 'Status', field: 'status.name', type: 'string' }
            ]
            this.sortOptions.initialSortBy = {
                field: 'value_with_avg_cp',
                type: 'desc'
            }
        // }
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' })
        }
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.$emit('finishedLoading', null)
            let params = {
                'filter[status]': 'ongoing',
                'filter[visible]': true,
                'filter[responsible]': this.employeeId,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid
            }
            projectService.find(params, (response) => {
                this.rows = response.data
                this.$emit('finishedLoading', this.rows.length)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        },
        totalValue () {
            if (this.rows) {
                let total = 0
                this.rows.forEach((project) => {
                    total += project.value
                })
                return total
            }
            return 0
        },
        totalValueWithCP () {
            if (this.rows) {
                let total = 0
                this.rows.forEach((project) => {
                    total += project.value_with_avg_cp
                })
                return total
            }
            return 0
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// ongoing.vue?7a473de6